import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import techdocsAddonsModule from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import authPlugin from '@backstage/plugin-auth';
import appVisualizerPlugin from '@backstage/plugin-app-visualizer';
import { navModule } from './modules/nav';
import { signInModule } from './modules/signIn';

export default createApp({
  features: [
    catalogPlugin,
    notificationsPlugin,
    signalsPlugin,
    searchPlugin,
    techdocsPlugin,
    techdocsAddonsModule,
    scaffolderPlugin,
    kubernetesPlugin,
    userSettingsPlugin,
    apiDocsPlugin,
    orgPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    authPlugin,
    appVisualizerPlugin,
    navModule,
    signInModule,
  ],
});
